module.exports = __webpack_public_path__ + "static/media/highlighter.9e81d3c5.svg";